import React from 'react';
import LocationDisabledBadge from './LocationDisabledBadge';
import './DisabledLocationAccessBlockedBanner.css';

function DisabledLocationAccessBlockedBanner({ disabledLocations = [] }) {
  if (!disabledLocations.length) return null;

  const names = disabledLocations.map((loc) => loc.name).filter(Boolean);

  return (
    <div className="disabled-location-access-blocked-banner" role="alert">
      <div className="disabled-location-access-blocked-banner__title">
        Location access not allowed
      </div>
      <div className="disabled-location-access-blocked-banner__body">
        {names.length > 0 && (
          <p className="disabled-location-access-blocked-banner__locations">
            {names.map((name) => (
              <span key={name} className="disabled-location-access-blocked-banner__location-item">
                {name}
                <LocationDisabledBadge />
              </span>
            ))}
          </p>
        )}
        <p>
          The selected location is disabled, so access to its operational data is not allowed.
          Re-enable the location from Location Management to restore access.
        </p>
      </div>
    </div>
  );
}

export default DisabledLocationAccessBlockedBanner;
